<template>
  <div>
    <van-nav-bar
      :title="title"
      right-text="返回"
      @click-right="onClickRight"
    />
    <div v-if="needshowLoding">
      Loading 。。。
    </div>
    <!-- <h2 class="contentTitle">{{ title }}</h2> -->
    <van-image width="10rem" height="10rem" fit="contain" :src="image" />
    <div v-html="introduction" class="html-box"></div>
    <van-cell-group style="margin-top:10px;margin-bottom:10px;">
      <van-cell title="活动类型" :value="type" />
      <van-cell title="活动地点" :value="location" />
      <van-cell title="活动开始时间" :value="startTime" />
      <van-cell title="活动结束时间" :value="endTime" />
      <van-cell title="活动参与人数" :value="headCount" />
    </van-cell-group>

    <template v-if="checkEnrolled">
      <van-button
        type="primary"
        style="margin-top:10px;margin-bottom:50px;margin-left:10px;margin-right:10px;"
        >活动已报名，请联系管理员审核</van-button
      >
    </template>

    <template v-else>
      <van-divider
        :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
      >
        填报信息
      </van-divider>
      <!-- 要根据不同的需要填报的信息展示不同的组件。
    type(单行文本框0、数字输入框1、员工2、文件3、单选4、多选5) 
    -->

      <van-cell-group style="margin-top:10px;margin-bottom:10px;">
        <div v-for="(item, index) in enrollAddInfos" :key="index">
          <template v-if="item.type == 0">
            <van-field
              v-model="enrollAddInfosPostData[index].content"
              autosize
              input-align="center"
              :label="item.keyName"
              :placeholder="item.defaultcontent"
            />
          </template>
          <template v-else-if="item.type == 1">
            <van-field
              v-model="enrollAddInfosPostData[index].content"
              autosize
              type="number"
              input-align="center"
              :label="item.keyName"
              :placeholder="item.defaultcontent"
            />
          </template>
          <template v-else-if="item.type == 2">
            <!-- 员工给workid -->
            <van-field
              v-model="enrollAddInfosPostData[index].content"
              autosize
              input-align="center"
              :label="item.keyName"
              :placeholder="item.defaultcontent"
            />
          </template>
          <template v-else-if="item.type == 3">
            <van-cell
              :title="item.keyName"
              :value="item.defaultcontent"
              @click="uploadimage(index)"
            />
            <template
              v-if="
                enrollAddInfosPostData[index].content != null &&
                  enrollAddInfosPostData[index].content.length > 0
              "
            >
              <!-- <p v-html="enrollAddInfosPostData[index].content"/> -->
              <van-image
                width="10rem"
                height="10rem"
                fit="scale-down"
                :src="enrollAddInfosPostData[index].content"
            /></template>
          </template>
          <template v-else-if="item.type == 4">
            <!-- 单选4，就存入信息 -->
            <van-cell :title="item.keyName" :value="item.defaultcontent" />
            <van-radio-group v-model="enrollAddInfosPostData[index].content">
              <van-cell-group>
                <van-cell
                  v-for="(itemChoose, j) in item.activityInfosChooseMo"
                  :key="j"
                  :title="itemChoose.chooseContent"
                  clickable
                  @click="
                    enrollAddInfosPostData[index].content =
                      itemChoose.chooseContent
                  "
                >
                  <template #right-icon>
                    <van-radio :name="itemChoose.chooseContent" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </template>
          <template v-else-if="item.type == 5">
            <!-- 多选5，就存入信息  :value= -->
            <van-cell :title="item.keyName" :value="item.defaultcontent" />
            <van-checkbox-group
              v-model="enrollAddInfosPostData[index].contentArray"
            >
              <van-cell-group>
                <van-cell
                  v-for="(itemChoose, j) in item.activityInfosChooseMo"
                  :key="j"
                  :title="itemChoose.chooseContent"
                  clickable
                  @click="checkedtoggle(j)"
                >
                  <template #right-icon>
                    <van-checkbox
                      :name="itemChoose.chooseContent"
                      ref="checkboxes"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </template>
        </div>
      </van-cell-group>
      <div id="hideUpload" style="display: none"></div>

      <van-button
        type="primary"
        style="margin-top:10px;margin-bottom:50px;margin-left:10px;margin-right:10px;"
        @click="postAttendActivity"
        >活动报名</van-button
      >
    </template>
    <van-button
      type="info"
      style="margin-top:10px;margin-bottom:50px;margin-left:10px;margin-right:10px;"
      @click="backCommunity"
      >返回社区</van-button
    >
  </div>
</template>

<script>
import $ from "jquery"
import store from '../store'
import Vue from 'vue';
import { Button } from 'vant';
Vue.use(Button);



export default {

  data() {
    return {
      needshowLoding: true,
      checkEnrolled: false,
      title: "activity TITLE",
      introduction: "<p>activity CONTENT</p>",
      startTime: "",
      endTime: "",
      headCount: 0,
      image: "",
      isPublic: false,
      location: "",
      type: "",
      enrollAddInfos: [],
      enrollAddInfosPostData: [],

      enrolledActivity: false,

      domUtils: {
        on: function (dom, event, fun) {
          dom.addEventListener(event, fun);
        },
        un: function (dom, event, fun) {
          dom.removeEventListener(event, fun);
        }
      },
      commonUploadButtonInput: "",
      commonUploadButtonSuccessCall: "",


    };
  },
  created: function () {
    this.getActivityContent();
    this.getActivityAddInfo();
    this.checkActivityEnrolled();
    // this.getActivityReward();

  },
  mounted: function () {

    this.initUploadPicButton("hideUpload");
  },
  methods: {
    checkedtoggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    onClickRight() {
      this.$router.go(-1);
    },


    // onChange(event) {
    //   this.setData({
    //     result: event.detail
    //   });
    // },
    // checkedOnChange() {
    //   alert("event.detail");
    //   // result: 
    //   // });
    // },

    // singletoggle(event) {
    //   const { index } = event.currentTarget.dataset;
    //   const checkbox = this.selectComponent(`.checkboxes-${index}`);
    //   checkbox.toggle();
    // },

    // noop() { },



    getActivityContent() {
      const _this = this;
      // debugger
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url: APIBASEURL + "/activity/userGetActivity",
        data: JSON.stringify({
          jwt: store.state.jwt, //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs",
          id: _this.$route.params.id
        }),
        async: false,
        error: function (request) {
          alert("/activity/userGetActivity发送请求失败" + request);
        },
        success: function (response) {
          // alert("/activity/userGetActivity成功，response是:" + JSON.stringify(response));
          if (response.code != "200") {
            alert("/activity/userGetActivity返回错误信息" + response.msg);
          } else {
            _this.needshowLoding = false;
            _this.title = response.data.title;
            _this.introduction = response.data.introduction;
            _this.startTime = response.data.startTime;
            _this.endTime = response.data.endTime;
            _this.headCount = response.data.headCount;
            _this.image = response.data.image;
            _this.isPublic = response.data.isPublic;
            _this.location = response.data.location;
            _this.type = response.data.type;
          }
        },
      });
      return;
    },
    getActivityAddInfo() {
      const _this = this;
      // debugger
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url: APIBASEURL + "/activity/userListActivityAddInfo",
        data: JSON.stringify({
          jwt: store.state.jwt, //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs",
          id: _this.$route.params.id
        }),
        async: false,
        error: function (request) {
          alert("/activity/userListActivityAddInfo发送请求失败" + request);
        },
        success: function (response) {
          // alert("/activity/userListActivityAddInfo成功，response是:" + JSON.stringify(response));
          // [{"activityInfosChooseMo":[],"defaultcontent":"上传文件","id":9,"isRequired":true,"keyName":"申报表P1照片","type":3},{"activityInfosChooseMo":[],"defaultcontent":"上传文件","id":10,"isRequired":true,"keyName":"申报表P2照片","type":3}]
          if (response.code != "200") {
            alert("/activity/userListActivityAddInfo返回错误信息" + response.msg);
          } else {
            _this.needshowLoding = false;
            _this.enrollAddInfos = response.data;
            for (var i = 0; i < _this.enrollAddInfos.length; i++) {
              var oneAddInfo = { activityAddInfoId: _this.enrollAddInfos[i].id, jwt: store.state.jwt, content: "", contentArray: [] };
              _this.enrollAddInfosPostData.push(oneAddInfo);

              for (var j = 0; j < _this.enrollAddInfos[i].activityInfosChooseMo.length; j++) {
                _this.enrollAddInfos[i].activityInfosChooseMo[j].chooseContent = _this.enrollAddInfos[i].activityInfosChooseMo[j].keyName + " : " + _this.enrollAddInfos[i].activityInfosChooseMo[j].content;
              }
            }

            // [{
            // "activityAddInfoId": 0,
            // "content": "string",
            // "jwt": "string"
            // }]
            // _this.activityTitle = response.data.title;
            // _this.activityContent = response.data.content;

          }
        },
      });
      return;
    },
    // getActivityReward() {
    // },

    UEGetFormUploadInfo() {
      var result = $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url: "https://www.gongdiangonghui.cn" + "/api/qiniu/getFilePathAndFileUrlAndTokenForUser",
        data: JSON.stringify({ jwt: localStorage.getItem("jwt") }),
        async: false,
        error: function (request) {
          alert("系统错误，请联系管理员" + request);
        },
        success: function (data) {
          return data;
        }
      })
      return JSON.parse(result.responseText).data;
    },

    uploadimage(i) {

      this.commonUploadButtonSuccessCall = function (link) {
        this.enrollAddInfosPostData[i].content = link;
        // this.addContent[name] = link;

        // alert(link);
      }.bind(this);
      this.commonUploadButtonInput.accept = "image/*";
      this.commonUploadButtonInput.click();
    },


    initUploadPicButton(elementId, width, height) {
      var containerBtn = document.getElementById(elementId);
      if (containerBtn == null) {
        return;
      }
      width = width || 20;
      height = height || 20;
      var w = containerBtn.offsetWidth || width,
        h = containerBtn.offsetHeight || height,
        btnIframe = document.createElement('iframe'),
        btnStyle = 'display:block;width:' + w + 'px;height:' + h + 'px;overflow:hidden;border:0;margin:0;padding:0;position:absolute;top:0;left:0;filter:alpha(opacity=0);-moz-opacity:0;-khtml-opacity: 0;opacity: 0;cursor:pointer;';
      //btnStyle = 'display:block;width:100%;height:100%;overflow:hidden;border:0;margin:0;padding:0;position:absolute;top:0;left:0;filter:alpha(opacity=0);-moz-opacity:0;-khtml-opacity: 0;opacity: 0;cursor:pointer;';
      // this.domUtils.on = function (dom, event, fun) {
      //   dom.addEventListener(event, fun);
      // },
      //   this.domUtils.un = function (dom, event, fun) {
      //     dom.removeEventListener(event, fun);
      //   },
      this.domUtils.on(btnIframe, 'load', function () {

        var timestrap = (+new Date()).toString(36),
          wrapper,
          btnIframeDoc,
          btnIframeBody;

        btnIframeDoc = (btnIframe.contentDocument || btnIframe.contentWindow.document);
        btnIframeBody = btnIframeDoc.body;
        wrapper = btnIframeDoc.createElement('div');

        wrapper.innerHTML = '<form id="edui_form_' + timestrap + '" target="edui_iframe_' + timestrap + '" method="POST" enctype="multipart/form-data" action="' + '" ' +
          'style="' + btnStyle + '">' +
          '<input id="edui_input_' + timestrap + '" type="file" accept="image/*" name="' + 'file' + '" ' +//+ me.options.imageFieldName + '" ' +
          'style="' + btnStyle + '">' +
          '<input id="key" type="text" name="key" />' +
          '<input id="token" type="text" name="token" />' +
          '</form>' +
          '<iframe id="edui_iframe_' + timestrap + '" name="edui_iframe_' + timestrap + '" style="display:none;width:0;height:0;border:0;margin:0;padding:0;position:absolute;"></iframe>';

        //wrapper.className = 'edui-' + me.options.theme;
        //wrapper.id = me.ui.id + '_iframeupload';
        btnIframeBody.style.cssText = btnStyle;
        btnIframeBody.style.width = w + 'px';
        btnIframeBody.style.height = h + 'px';
        //btnIframeBody.style.width = '100%';
        //btnIframeBody.style.height = '100%';
        btnIframeBody.appendChild(wrapper);

        if (btnIframeBody.parentNode) {
          btnIframeBody.parentNode.style.width = w + 'px';
          btnIframeBody.parentNode.style.height = w + 'px';
        }

        var form = btnIframeDoc.getElementById('edui_form_' + timestrap);
        var input = btnIframeDoc.getElementById('edui_input_' + timestrap);
        var iframe = btnIframeDoc.getElementById('edui_iframe_' + timestrap);
        this.commonUploadButtonInput = input;

        this.domUtils.on(input, 'change', function () {
          if (!input.value) return;

          var formInfo = this.UEGetFormUploadInfo();

          // var loadingId = 'loading_' + (+new Date()).toString(36);
          //var params = utils.serializeParam(me.queryCommandValue('serverparam')) || '';

          //var imageActionUrl = me.getActionUrl(me.getOpt('imageActionName'));
          var allowFiles = null;//me.getOpt('imageAllowFiles');

          //me.focus();
          //me.execCommand('inserthtml', '<img class="loadingclass" id="' + loadingId + '" src="' + me.options.themePath + me.options.theme +'/images/spacer.gif" title="' + (me.getLang('simpleupload.loading') || '') + '" >');

          var callback = function () {
            try {
              var link;
              //
              // , json, loader 
              // body = (iframe.contentDocument || iframe.contentWindow.document).body,
              //result = body.innerText || body.textContent || '';
              //json = (new Function("return " + result))();


              var UEQiNiuBaseUrl = "http://cdn.learningpartner.club/";
              link = UEQiNiuBaseUrl + formInfo.imageURL;//me.options.imageUrlPrefix + json.url;
              //if(json.state == 'SUCCESS' && json.url) {
              //loader = me.document.getElementById(loadingId);
              //loader.setAttribute('src', link);
              //loader.setAttribute('_src', link);
              //    loader.setAttribute('title', json.title || '');
              //    loader.setAttribute('alt', json.original || '');
              //loader.removeAttribute('id');
              //domUtils.removeClasses(loader, 'loadingclass');
              //} else {
              //    showErrorLoader && showErrorLoader(json.state);
              //}
              this.commonUploadButtonSuccessCall(link);
            } catch (er) {
              // showErrorLoader && showErrorLoader(me.getLang('simpleupload.loadError'));
            }
            form.reset();
            this.domUtils.un(iframe, 'load', callback);
          }.bind(this);
          // function showErrorLoader(title) {
          //   if (loadingId) {
          //     var loader = me.getElementById(loadingId);
          //     loader && this.domUtils.remove(loader);
          //     me.fireEvent('showmessage', {  //me
          //       'id': loadingId,
          //       'content': title,
          //       'type': 'error',
          //       'timeout': 4000
          //     });
          //   }
          // }

          /* 判断后端配置是否没有加载成功 */
          /*if (!me.getOpt('imageActionName')) {
              errorHandler(me.getLang('autoupload.errorLoadConfig'));
              return;
          }*/
          // 判断文件格式是否错误
          var filename = input.value,
            fileext = filename ? filename.substr(filename.lastIndexOf('.')) : '';
          if (!fileext || (allowFiles && (allowFiles.join('') + '.').indexOf(fileext.toLowerCase() + '.') == -1)) {
            // showErrorLoader(me.getLang('simpleupload.exceedTypeError'));
            return;
          }

          this.domUtils.on(iframe, 'load', callback);
          //form.action = utils.formatUrl(imageActionUrl + (imageActionUrl.indexOf('?') == -1 ? '?':'&') + params);
          form.action = formInfo.uploadPath;
          form.token.value = formInfo.token;
          form.key.value = formInfo.imageURL;
          //form.submit();
          //globaldate.imgurl = data.data.imageURL;
          form.submit();
        }.bind(this));

      }.bind(this));

      btnIframe.style.cssText = btnStyle;
      containerBtn.appendChild(btnIframe);
    },

    checkActivityEnrolled() {

      const _this = this;
      // debugger
      let APIBASEURL = "https://www.gongdiangonghui.cn";
      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url: APIBASEURL + "/activity/userCheckEnrollActivity",
        data: JSON.stringify({
          jwt: store.state.jwt, //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs",
          id: _this.$route.params.id,
        }),
        async: false,
        error: function (request) {
          request;
          // alert("/activity/userEnrollActivity发送请求失败" + request);
        },
        success: function (response) {
          //  alert("/activity/userCheckEnrollActivity成功，response是:" + JSON.stringify(response));
          if (response.code != "200") {
            // alert("/activity/userEnrollActivity返回错误信息" + response.msg);
          } else {
            _this.checkEnrolled = response.data;
            _this.needshowLoding = false;
          }
        },
      });
      return

    },

    backCommunity() {
      this.$router.push("/community");
    },
    postAttendActivity() {

      const _this = this;
      // debugger
      let APIBASEURL = "https://www.gongdiangonghui.cn";

      for (var i = 0; i < _this.enrollAddInfos.length; i++) {
        if (_this.enrollAddInfos[i].type == 5) {
          if (_this.enrollAddInfosPostData[i].contentArray.length > 0) {
            _this.enrollAddInfosPostData[i].content = _this.enrollAddInfosPostData[i].contentArray.toString();
          }
        }

      }


      $.ajax({
        cache: false,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        url: APIBASEURL + "/activity/userEnrollActivity",
        data: JSON.stringify({
          jwt: store.state.jwt, //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs",
          activityId: _this.$route.params.id,
          addInfoList: _this.enrollAddInfosPostData,
        }),
        async: false,
        error: function (request) {
          // request;
          alert("/activity/userEnrollActivity发送请求失败" + request);
        },
        success: function (response) {
          // alert("/activity/userEnrollActivity成功，response是:" + JSON.stringify(response));
          if (response.code != "200") {
            // {"code":"400","data":null,"msg":"id:11 activityAddInfo is required"}
            // alert("/activity/userEnrollActivity返回错误信息" + response.msg);
            if (response.code == "400") {
              alert("报名信息未填全");
            }
          } else {
            alert("提交成功，等待管理员审核。");
            
            _this.$router.push("/home");

            
            _this.needshowLoding = false;
          }
        },
      });
      return

    }
  }
};
</script>

<style  scoped>
.html-box >>> img {
  display: block;
  margin: 0 auto;
  max-width: 100% !important;
  height: auto !important;
}

.html-box >>> p {
  max-width: 100%;
  word-break: break-all;
  font-size: 15px !important;
}

.html-box >>> span {
  max-width: 100%;
  word-break: break-all;
  font-size: 15px !important;
}

.html-box >>> table {
  width: 100%;
}
.contentTitle {
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding-left: 15px;
  font-weight: 700;
  margin: 10px 10px;
  text-align: left;
}

.van-cell__value {
  /* color:  #2c3e50;  */
  text-align: left;
  word-wrap: break-word;
}
.value-class {
  flex: none !important;
}
.van-cell__title {
  text-align: left;
}
/* .van-cell.van-field >>>.van-cell__title .van-field__label {
  color: red;;
  text-align: left;
  word-wrap: break-word;
} */
</style>
